import { DataProvider, LeaguesRetriever } from "../../Typings";
import { BFFGateway } from "sb-resp-lib";
import { TopLeaguesRetriever } from "../TopLeaguesRetriever";
import { CouponLeaguesRetriever } from "../CouponLeaguesRetriever";
import { AllLeaguesRetriever } from "../AllLeaguesRetriever";

export class RetrieverChooser {
    private bff: BFFGateway;
    private dataProvider: DataProvider;
    private loadedData: Function;

    constructor(bffGateway: BFFGateway, dataProvider: DataProvider, loadedData: Function) {
        this.bff = bffGateway;
        this.dataProvider = dataProvider;
        this.loadedData = loadedData;
    }

    selectRetriever(sportId: string = "0", leagueIds: string[] = []): LeaguesRetriever {
        this.dataProvider.sportId = sportId;
        this.dataProvider.leagueIds = leagueIds;

        if (this.dataProvider.leagueIds.length) {
            return new CouponLeaguesRetriever(this.bff, this.dataProvider, this.loadedData);
        }

        if (this.dataProvider.isTopLeaguesOnly) {
            return new TopLeaguesRetriever(this.bff, this.dataProvider, this.loadedData);
        }

        return new AllLeaguesRetriever(this.bff, this.dataProvider, this.loadedData);
    }

}